import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class GoPagination extends Vue {
  @Prop({ type: Number, required: true }) currentPage: number;
  @Prop({ type: Number, required: true }) totalPages: number;

  @Emit('change-page') changePage(page: number) {}

  get maxVisible() {
    return 5;
  }

  get startPage() {
    let start = Math.max(this.currentPage - Math.floor(this.maxVisible / 2), 1);
    if (start + this.maxVisible - 1 > this.totalPages) {
      start = Math.max(this.totalPages - this.maxVisible + 1, 1);
    }
    return start;
  }

  get endPage() {
    return Math.min(this.startPage + this.maxVisible - 1, this.totalPages);
  }

  get visiblePages() {
    const pages = [];
    for (let i = this.startPage; i <= this.endPage; i++) {
      pages.push(i);
    }
    return pages;
  }

  onChangePage(page) {
    if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
      this.changePage(page);
    }
  }
}
